import React from 'react';
import useCache from 'src/hooks/useCache';
import CommentCard from './CommentCard';
import { Item } from 'src/interfaces/api/ActivityWall';
import useActivityWall from 'src/hooks/api/useActivityWall';

interface Props {
  wallId: string;
  open: boolean;
  onClose: () => void;
}

const CommentCardContainer: React.FC<Props> = ({ wallId, ...props }) => {
  const [items, setItems] = useCache<Item[]>();
  const { addPost } = useActivityWall();

  const handleAddPost = async (title: string, comment: string, attachments?: File[]) => {
    const newItem = await addPost(wallId, title, comment, attachments);
    setItems([...(items ?? []), newItem]);
    props.onClose();
  };

  return <CommentCard onAddPost={handleAddPost} {...props} />;
};

export default CommentCardContainer;
